/**
 * Delvia: 600 TL ve üzeri sepete otomatik "Hediye Çekmeceli Kutu".
 *
 * Kural (Patron 2026-07-02): sepet toplamı eşiğe ulaştığı anda 0 TL'lik hediye
 * kutusu sepete otomatik eklenir; altına düşünce otomatik silinir. Ürün
 * aramadan/koleksiyonlardan gizli (seo.hidden=1) ve do_not_touch tag'li —
 * tek giriş yolu bu script.
 *
 * Mekanizma delvia-cart-discount.js ile aynı: sepet mutasyonu section-bundle
 * ile yapılır, dönen section HTML'leri FoxTheme pubsub cartUpdate + cart:updated
 * ile temaya morphlatılır (drawer canlı yenilenir, reload yok).
 *
 * Döngü koruması: kendi mutasyonumuzun tetiklediği cart:updated, `enforcing`
 * bayrağıyla yutulur; enforce idempotent (durum doğruysa hiçbir şey yapmaz).
 * Bilinen sınır: "Buy it now" (direkt checkout) sepeti atlar — hediye eklenmez.
 */
(function () {
  if (window.delviaFreeGiftInit) return;
  window.delviaFreeGiftInit = true;

  var GIFT_VARIANT_ID = 45634002190515; // "Hediye Çekmeceli Kutu" (0 TL, DELVIA-GIFT-BOX)
  var THRESHOLD_CENTS = 60000; // 600 TL (kuruş)

  var enforcing = false;

  function foxReady() {
    return window.FoxTheme && FoxTheme.utils && FoxTheme.routes && FoxTheme.pubsub;
  }

  async function fetchCart() {
    var r = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    return r.json();
  }

  function giftLine(cart) {
    return (cart.items || []).find(function (it) {
      return it.variant_id === GIFT_VARIANT_ID;
    });
  }

  async function mutateCart(url, payload) {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );
    var cfg = FoxTheme.utils.fetchConfig('javascript');
    cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
    payload.sections = sectionsToBundle.join(',');
    payload.sections_url = window.location.pathname;
    cfg.body = JSON.stringify(payload);
    var parsed = await (await fetch(url, cfg)).json();
    var cartJson = await fetchCart();
    cartJson.sections = parsed.sections;
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartJson } }));
  }

  async function enforce(cartMaybe) {
    if (enforcing || !foxReady()) return;
    enforcing = true;
    try {
      var cart = cartMaybe && cartMaybe.items ? cartMaybe : await fetchCart();
      var gift = giftLine(cart);
      // Eşik, hediyenin kendisi hariç toplam üzerinden (hediye 0 TL — yine de sağlam olsun)
      var eligible = cart.total_price - (gift ? gift.final_line_price : 0);
      var giftless = (cart.items || []).length - (gift ? 1 : 0);
      if (eligible >= THRESHOLD_CENTS && giftless > 0) {
        if (!gift) {
          await mutateCart(FoxTheme.routes.cart_add_url, {
            items: [{ id: GIFT_VARIANT_ID, quantity: 1 }],
          });
        } else if (gift.quantity !== 1) {
          await mutateCart(FoxTheme.routes.cart_change_url, { id: gift.key, quantity: 1 });
        }
      } else if (gift) {
        await mutateCart(FoxTheme.routes.cart_change_url, { id: gift.key, quantity: 0 });
      }
    } catch (_e) {
      /* sessiz — hediye mantığı sepet akışını asla bozmamalı */
    } finally {
      enforcing = false;
    }
  }

  document.addEventListener('cart:updated', function (e) {
    enforce(e && e.detail && e.detail.cart);
  });
  document.addEventListener('product-ajax:added', function () {
    enforce();
  });

  function boot() {
    // FoxTheme runtime'ı geç yüklenebilir — hazır olana dek kısa aralıkla bekle
    if (!foxReady()) return void setTimeout(boot, 400);
    enforce();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
